<template>
  <button>
    ·<span>{{ props.text }}</span>
  </button>
</template>

<script setup>
  import { Props } from './props';
  //----------------------------------
  const props = defineProps(Props());
</script>

<style lang="scss" scoped>
  @import "./styles.scss";
</style>